'use strict';

import { Dispatcher } from 'flux';
var AppDispatcher = new Dispatcher();

AppDispatcher.handleAction = function (action) {
    this.dispatch({
        source: 'VIEW_ACTION',
        action,
    });
};

export default AppDispatcher;